export default {"src":"/_next/static/media/calendarTime_64.ba916b9a.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};